const TRON_ADDRESS_PATTERN = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

export function normalizeTronAddress(value) {
  const address = String(value || '').trim();
  if (!TRON_ADDRESS_PATTERN.test(address)) {
    const error = new TypeError('Invalid TRC20 address');
    error.code = 'INVALID_TRON_ADDRESS';
    throw error;
  }
  return address;
}

